var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeutralIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "11469.184 755 28.428 28.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00a1e1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11469.184 755)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M315.614,0a14.214,14.214,0,1,0,14.214,14.214A14.228,14.228,0,0,0,315.614,0Zm0,26.892a12.679,12.679,0,1,1,12.678-12.678,12.635,12.635,0,0,1-12.678,12.678Zm0,0",
    transform: "translate(-301.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M371.373,80.737a1.537,1.537,0,1,1-1.537-1.537,1.532,1.532,0,0,1,1.537,1.537Zm0,0",
    transform: "translate(-360.268 -69.692)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M450.573,80.737a1.537,1.537,0,1,1-1.537-1.537,1.532,1.532,0,0,1,1.537,1.537Zm0,0",
    transform: "translate(-429.96 -69.692)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M384.858,143.4m4.85,3.554H380.2v-1.537h9.508Z",
    transform: "translate(-370.74 -126.184)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralIcon);
export default __webpack_public_path__ + "static/media/neutral_icon.39ff2369b730732c3829483e97a706aa.svg";
export { ForwardRef as ReactComponent };